// import Libraries
import React, {Component} from 'react'
import {connect} from 'react-redux';

//import Components
import { Container,  Row, Col, Button, Input, Label, InputGroupAddon, InputGroup } from 'reactstrap';

import MainCategory from './Category/MainCategory';
import NotClassifiedCategory from './Category/NotClassifiedCategory';

import Loading from '../../../components/Loading/Loading';

import * as productActions from './Category/Product/actions/productActions';
import * as categoryActions from './actions/categoryActions';

//import Styles
import '../Admin.css'

class ProductManager extends Component {
    constructor(props) {
        const {products} = props;
        super(props);
        this.state = {
            koMainText : '',
            enMainText : '',

            editing : false,
        }
    }

    makeEditAnything = () => {
        if(this.state.editing) {
            global.confirm(
                "편집중인 항목이 있습니다. 편집을 완료 해 주십시오"
            );
            return false;
        } else {
            this.setState({
                editing : true
            })
            return true;
        }
    }

    makeEditDoneAnything = () => {
        this.setState({
            editing : false
        })
    }

    // toggleEditing = (id) => {
    //     const currentEditingId = this.state.editingId;
    //     let newEditingId  = -1;
    //     let editing = [...this.state.editing];

    //     const currentIndex = this.props.products.findIndex((product) => {
    //         return product.id === currentEditingId;
    //     })
    //     const newIndex = this.props.products.findIndex((product) => {
    //         return product.id === id;
    //     })

    //     if(this.state.editingId === id) {
    //         editing[currentIndex] = !editing[currentIndex]
    //         newEditingId = -1;
    //     }
    //     else if(currentEditingId !== id) {
    //         if(id === null || id === undefined) {
    //             editing[currentIndex] = !editing[currentIndex];
    //             newEditingId = -1;
    //         } else if(currentEditingId  === -1) {
    //             newEditingId = id;
    //             editing[newIndex] = !editing[newIndex]
    //         }
    //         else {
    //             editing[currentIndex] = !editing[currentIndex];
    //             newEditingId = id;
    //             editing[newIndex] = !editing[newIndex];
    //         }
    //     }
    //     this.setState({
    //         editing : editing,
    //         editingId : newEditingId
    //     })
    // }
    // askCancleEditing = (func, id) => {
    //     if(this.state.editingId !== -1) {
    //         if(this.state.editingId === id) {
    //             if(func) func();
    //         }
    //         else {
    //             const result = global.confirm('편집중인 상품이 있습니다. 편집을 취소하겠습니까?');
    //             if (result) {
    //                 if (func) func();
    //             }
    //         }
    //     }
    //     else {
    //         if (func) func(); 
    //     }
    // }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    render() {
        const {products, category} = this.props;

        let notEditingArray = [];
        const notClassifiedProducts = products.filter((product, index) => {
            if(product.category.mainCategory === -1) {
                notEditingArray.push(this.state.editing[index]);
                return true;
            }
        })
        let deletedEditingArray = [];
        const deletedProducts = products.filter((product, index) => {
            if(product.category.mainCategory === -2) {
                deletedEditingArray.push(this.state.editing[index]);
                return true;
            }
        })

        const mainButtonDisabled = this.state.koMainText === '' || this.state.enMainText === '';

        return (
            <div className="admin-element">
                <Container>
                    <h1>
                        상품관리
                    </h1>
                    <hr />
                    <div>
                        <Row>
                        <InputGroup style={{padding: "18px"}}>
                            <InputGroupAddon addonType="prepend">대분류추가</InputGroupAddon>
                            <Input 
                                type="text" 
                                name="koMainText"
                                value={this.state.mainText} 
                                onChange={this.handleOnChange} 
                                placeholder="대분류"/>
                            <Input 
                                type="text" 
                                name="enMainText"
                                value={this.state.mainText}
                                onChange={this.handleOnChange}
                                placeholder="Large Category" 
                            />
                            <InputGroupAddon addonType="append">
                                <Button 
                                    onClick={() => this.props.onAddNewMainCategory({
                                            ko : this.state.koMainText,
                                            en : this.state.enMainText
                                    })}
                                    disabled={mainButtonDisabled}
                                >
                                    추가
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                        </Row>
                        {
                            category.mainCategory.map((main, index) => {
                                const filteredProducts = products.filter((product, filterIndex)=> {
                                    if(product.category.mainCategory === index) {
                                        return true;
                                    }
                                })

                                return (
                                    <MainCategory 
                                        makeEditAnything={this.makeEditAnything}
                                        makeEditDoneAnything={this.makeEditDoneAnything}
                                        category={main} 
                                        products={filteredProducts}
                                        index={index} 
                                        key={index}
                                    />
                                );
                            })
                        }
                        <NotClassifiedCategory
                            name="미분류"
                            makeEditAnything={this.makeEditAnything}
                            makeEditDoneAnything={this.makeEditDoneAnything}
                            products={notClassifiedProducts}
                        />
                        <NotClassifiedCategory
                            name="삭제된 상품"
                            makeEditAnything={this.makeEditAnything}
                            makeEditDoneAnything={this.makeEditDoneAnything}
                            products={deletedProducts}
                        />
                    </div>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        products : state.products,
        category : state.category
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddNewMainCategory : (text)=> {
            dispatch(categoryActions.addNewMainCategory(text));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductManager);


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/ProductManager.js